import { Button, IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Menu, MenuButton } from '@retail/components';
import { SupplierItemAssortmentTag } from '@retail/products/types';
import { AssortmentTag } from '@retail/my-assortment/types';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  assortmentTags: AssortmentTag[];
  validFrom?: Date;
  validTo?: Date;
  excludedTagIds?: number[];
  tooltip?: string;
  handleTagChange: (tag: SupplierItemAssortmentTag) => void;
}
export function AddTagMenu({
  assortmentTags,
  validFrom,
  validTo,
  excludedTagIds,
  tooltip,
  handleTagChange,
}: Props) {
  const t = useProductsTFunction();
  const selectableTags = excludedTagIds
    ? assortmentTags.filter((tag) => !excludedTagIds.includes(tag.id))
    : assortmentTags;

  return (
    <Menu>
      {({ onClose }) => (
        <>
          <Tooltip title={tooltip ?? ''}>
            <MenuButton component={IconButton} sx={{ padding: 0 }}>
              <Add fontSize="small" />
            </MenuButton>
          </Tooltip>
          {selectableTags.length === 0 ? (
            <MenuItem disabled>
              <Typography variant="body3">{t('products.mgItem.assortmentTags.noTags')}</Typography>
            </MenuItem>
          ) : (
            selectableTags.map((tag) => (
              <MenuItem
                key={tag.id}
                LinkComponent={Button}
                onClick={() => {
                  handleTagChange({
                    tagName: tag.name,
                    tagId: tag.id,
                    validFrom: validFrom ?? new Date(),
                    validTo,
                  });
                  onClose();
                }}
              >
                {tag.name}
              </MenuItem>
            ))
          )}
        </>
      )}
    </Menu>
  );
}
